import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { initReportClone } from './report-clone.actions';
import { recentlyClonedReport, reportCloneLoaded } from './report-clone.selectors';

@Injectable({
  providedIn: 'root',
})
export class ReportCloneFacade {
  static Actions = { initReportClone };
  recentlyClonedReport$ = this.store.select(recentlyClonedReport);

  constructor(private readonly store: Store) {}

  public reportCloneLoaded$(reportId: string): Observable<boolean> {
    return this.store.select(reportCloneLoaded(reportId)).pipe(map((hasLoaded) => hasLoaded ?? true));
  }

  public dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
